var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 20C17.4 17.7 18 15.2 18 12.5C18 9.8 17.4 7.2 16.3 5M12.7 18.3001C13.5 16.5001 14 14.5001 14 12.5001C14 10.5001 13.5 8.4001 12.7 6.6001M9.1001 16.5999C9.7001 15.2999 10.0001 13.8999 10.0001 12.4999C10.0001 11.0999 9.7001 9.5999 9.1001 8.3999M5.5 14.8001C5.8 14.1001 6 13.3001 6 12.5001C6 11.7001 5.8 10.8001 5.5 10.1001",
    stroke: "#0A0A0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceIcon);
export default __webpack_public_path__ + "static/media/voiceIcon.b687ce552c2f6d9a3f671dd6034f02d4.svg";
export { ForwardRef as ReactComponent };